module.exports = __webpack_public_path__ + "static/TQJ-51155adb0232850bdb074fc1e1c49d9b.jpg";